"use client";

import { useState } from "react";
import { formatMoney } from "@/lib/format";
import { useCart } from "@/store/hooks";

function getLineImage(item) {
  return (
    item?.thumbnail ||
    item?.variant?.product?.thumbnail ||
    item?.variant?.product?.images?.[0]?.url ||
    "/assets/images/product-placeholder.png"
  );
}

function getLineSize(item, orderType) {
  const title = item?.variant_title || item?.variant?.title || "";

  if (title && !/^default( variant)?$/i.test(title)) {
    return orderType === "takeout" && /^regular$/i.test(title)
      ? "Regular"
      : title;
  }

  return orderType === "takeout" ? "1 order" : "";
}

export default function CartItemRow({ item, orderType }) {
  const { updateItemQuantity, removeItem } = useCart(orderType);
  const [busy, setBusy] = useState(false);
  const quantity = Number(item?.quantity || 0);
  const currency = item?.currency_code || "cad";
  const lineTotal = item?.total ?? Number(item?.unit_price || 0) * quantity;
  const size = getLineSize(item, orderType);

  async function update(quantityValue) {
    if (busy) return;
    setBusy(true);

    try {
      await updateItemQuantity(item.id, quantityValue);
    } finally {
      setBusy(false);
    }
  }

  async function remove() {
    if (busy) return;
    setBusy(true);

    try {
      await removeItem(item.id);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="asian-bucket-cart-item-main-wrapper">
      <div className="asian-bucket-cart-item-image-main-wrapper">
        <img src={getLineImage(item)} alt={item?.product_title || item?.title || "Product"} />
      </div>

      <div className="asian-bucket-cart-item-content-main-wrapper">
        <h3>{item?.product_title || item?.title}</h3>
        {size && <p>{size}</p>}
        <strong>{formatMoney(lineTotal, currency)}</strong>
      </div>

      <div className="asian-bucket-cart-item-actions-main-wrapper">
        <div className="asian-bucket-cart-item-quantity-main-wrapper">
          <button
            type="button"
            disabled={busy}
            onClick={() => update(quantity - 1)}
            aria-label={`Remove one ${item?.product_title || item?.title}`}
          >
            −
          </button>
          <span>{quantity}</span>
          <button
            type="button"
            disabled={busy}
            onClick={() => update(quantity + 1)}
            aria-label={`Add one ${item?.product_title || item?.title}`}
          >
            +
          </button>
        </div>

        <button
          type="button"
          className="asian-bucket-cart-item-delete-button"
          disabled={busy}
          onClick={remove}
          aria-label={`Remove ${item?.product_title || item?.title} from basket`}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
